<script setup lang="ts" name="BaseCardNotAuthorized">
import { RouterLink } from 'vue-router';

import BaseButton from '~/components/BaseButton.vue';
import BaseCardState from '~/components/BaseCardState.vue';

import type { BaseCardStateSpacingType } from '~/types';

const {
  title = 'We Are Sorry. You Are Not Authorised to Access This Information',
  spacing = 'card-lg',
  button = 'Return to Home',
  message = '',
  styled,
} = defineProps<{
  title?: string;
  message?: string | null;
  styled?: boolean;
  spacing?: BaseCardStateSpacingType;
  button?: string | null;
}>();
</script>

<template>
  <BaseCardState
    :title="title"
    illustration="unauthorized"
    :spacing="spacing"
    :styled="styled"
    :message="message"
  >
    <template #message>
      <p class="mt-2 text-body-1 text-charcoal-9">
        Contact your admin or our
        <a
          href="mailto:myg2support@g2ocean.com"
          class="text-primary-8"
          target="_blank"
          >support team</a
        >
        for further details.
      </p>
    </template>
    <template #actions v-if="button">
      <BaseButton to="/">{{ button }}</BaseButton>
    </template>
  </BaseCardState>
</template>
